import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import qs from "query-string";
export var QueryParameters;
(function(QueryParameters) {
    QueryParameters.parse = function(search) {
        var queryParams = qs.parse(search);
        var page = parseInt(queryParams.page, 10);
        var maker_minimum = parseInt(queryParams.maker_minimum, 10);
        return _object_spread_props(_object_spread({}, queryParams), {
            page: !Number.isNaN(page) ? page : undefined,
            maker_minimum: !Number.isNaN(maker_minimum) ? maker_minimum : undefined
        });
    };
    QueryParameters.stringify = function(queryParams) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var search = qs.stringify(queryParams);
        if (search && options.addQueryPrefix) {
            return "?" + search;
        }
        return search;
    };
})(QueryParameters || (QueryParameters = {}));
